/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

export const SET_APP_GLOBAL_ERROR = "SET_APP_GLOBAL_ERROR";

export const SET_DUNNING_DIALOG_DISMISSED = "SET_DUNNING_DIALOG_DISMISSED";
